import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CharacterProfile } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { Box, Divider } from '@mui/material';
import { ContactsList } from './ContactsList.js';
import { NoContactSelected } from './NoContactSelected.js';
import { WideToolbar } from './Toolbar.js';
const LIST_PANE_WIDTH = 350;
export function WideContactsView(props) {
    const { contacts, selectedContact, filterState, filterActions, factionOptions, onContactSelect, } = props;
    const appContext = useAppContext();
    const canEdit = appContext.getEffectivePermissionLevel() === 'game-master';
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }, children: [_jsx(WideToolbar, { ...filterState, ...filterActions, factionOptions: factionOptions }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'row', flex: 1, minHeight: 0 }, children: [_jsx(Box, { sx: {
                            width: LIST_PANE_WIDTH,
                            minWidth: LIST_PANE_WIDTH,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            borderRight: 1,
                            borderColor: 'divider',
                        }, children: _jsx(ContactsList, { contacts: contacts, selectedContactId: selectedContact?.id, onContactSelect: onContactSelect }) }), _jsx(Divider, { orientation: "vertical", flexItem: true }), _jsx(Box, { sx: { flex: 1, overflow: 'auto' }, children: selectedContact ? (_jsx(CharacterProfile, { character: selectedContact, canEdit: canEdit })) : (_jsx(NoContactSelected, {})) })] })] }));
}
//# sourceMappingURL=WideContactsView.js.map